import { render, staticRenderFns } from "./iconCopy.vue?vue&type=template&id=4de26114"
import script from "./iconCopy.vue?vue&type=script&lang=js"
export * from "./iconCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports